import React from 'react';
import styled from 'styled-components/macro';
import { useParentLevel } from '../../../contexts/pageContext';
import { useNomenclator } from '../../../contexts/nomenclatorContext';
import { nombreEleccion } from '../../../resources/constantes.json'
import Spinner from '../../../components/Spinner';
import { useEchartsModal, EchartsModal, Close, Button } from '../Hemiciclo/EchartsModal';
import { useTranslate } from '../../../contexts/languageContext';
import { getUrl, addStr, fmt } from '../../../utils';
import constantes from '../../../resources/constantes.json';
import GraficaDonut from '../../../components/Grafica/Donut';

const Mapa = React.lazy(() => import('../../Mapa'));

const ResumenPorTerritorios = ({camaraSeleccionada, eleccion, idHistorico, id}) => {
    const nomenclator = useNomenclator();
    const esHistorico = idHistorico != null;
    const ambito = nomenclator.ambitos[eleccion][id];
    const citrep = nombreEleccion[eleccion] === 'citrep';
		const { state: modalState, dispatch, events } = useEchartsModal();
    return (
        <article
					css={`
						position: relative;
					`}
				>
            <React.Suspense fallback={<Spinner/>}>
							{modalState.show && modalState.data && (
								<ModalMapaResultados
									id={id}
									data={modalState.data}
									ambito={nomenclator.ambitos[eleccion].find(e => e.c === addStr(modalState.data.name, 2, '00') )}
									nomenclator={nomenclator}
									dispatch={dispatch}
									eleccion={eleccion}
									page={constantes.nombreEleccion[eleccion]}
									esHistorico={esHistorico}
								/>
							)}
							<Mapa
									variant="resultados"
									amb={ambito.c}
									nomenclator={nomenclator}
									ambito={ambito}
									esHistorico={esHistorico}
									camaraSeleccionada={camaraSeleccionada}
									eleccion={eleccion}
									events={events}
									citrep={citrep}
							/>
            </React.Suspense>
        </article>
    )
}


export default ResumenPorTerritorios;

function ModalMapaResultados({ id, ambito, data, nomenclator, dispatch, eleccion, page, esHistorico }) {
  const t = useTranslate();
	const parentLevel = useParentLevel();
  return (
    <EchartsModal
      dispatch={dispatch}
      css={`
        position: absolute;
      `}
			empty={data.value.mesas === '0' || (data.value.mesas !== '0' && data.value.hayEmpate)}
    >
      <div
        css={`
					display:flex;
					flex-direction:column;
					height: 100%;
					justify-content: space-between;
        `}
      >
        <div>
          <div
            css={`
              display: flex;
              justify-content: space-between;
            `}
          >
            <div
              css={`
                font-weight: 500;
                font-size: 18px;
              `}
            >
              {ambito.n}
            </div>
            <div>
              <Close dispatch={dispatch} />
            </div>
          </div>
          {
            <div css="margin-top: 8px;
							text-transform: lowercase;
							::first-letter {
							text-transform: uppercase;
							}">
				   {data.dialog.type === 'donut' ? data.dialog.label : data.dialog.singleLabel}
            </div>
          }
        </div>
				<>
				{
					data.dialog.type === 'donut' ? (
						<DialogDonut data={data} nomenclator={nomenclator}/>
					)
					: (
						<DialogGanador data={data} nomenclator={nomenclator} id={id} />
					)
				}
				</>
				{ !esHistorico && (
					<Button
						dispatch={dispatch}
						url={getUrl({ id: ambito.i, eleccion, nomenclator, page, parentLevel })}
					>
						{ t("goToResults")}
					</Button>
				)}
      </div>
    </EchartsModal>
  );
}

const DialogGanador = ({ data, nomenclator, id }) => {
	const t = useTranslate();
	const { nombre: nombrePartido, codpar } = nomenclator.partidos[data.value.codpar - 1]
	const logoPartido = `${constantes.rutas.logo}${(codpar).padStart(4, '0')}.webp`;
	const { codcan, nomcan, apecan, nomcan2, apecan2 } = data.value.cantotabla
	const basename = `${constantes.rutas.candidatos}${codcan.padStart(3, '0')}-${codpar.padStart(4, '0')}`;
	return ( data.value.mesas === '0' ? 
		(
			<SinInformacion>{t('sinInformacion')}</SinInformacion>
		) : data.value.hayEmpate ? (
			<SinInformacion>{t('hayEmpate')}</SinInformacion>
		) : (
			<PartidoGanador>
				<div
					css={`
						display:flex;
						justify-content: space-around;
					`}
				>
					<ImagenCandidato src={`${basename}-P.webp`} alt={'Imagen Presidente'}/>
					<ImagenCandidato src={`${basename}-V.webp`} alt={'Imagen VicePresidente'}/>
				</div>
				<CandidatoPresidente>{nomcan + ' ' + apecan}</CandidatoPresidente>
				<CandidatoVicepresidente>{nomcan2 + ' ' + apecan2}</CandidatoVicepresidente>
				<NombrePartido>{nombrePartido}</NombrePartido>
				<LogoPartido src={logoPartido}/>
				<div
					css={`
						display:flex;
						justify-content: space-around;
					`}
				>
					<Porcentaje>{data.value.pvot}</Porcentaje>
					<Votos>{fmt(data.value.vot) }</Votos>
				</div>
			</PartidoGanador>
		)
	)
}


const DialogDonut = ({ data, nomenclator }) => {
	const t = useTranslate();
	return (
		<div 
			css={`
				display:flex;
				flex-direction:column;
				height:230px;
				margin-bottom: 1rem;
			`}
		>
			<GraficaDonut value={data.data.value} color={data.itemStyle.color} name={data.dialog.label} isDialog={true}/>
			<div
				css={`text-align: center`} 
			>
				{ data.data.sinInfo ? 
					t('sinInformacion')
					:fmt(data.data.field2) + ' ' + data.dialog.label.toLowerCase()
				}
			</div>
		</div>
	)
}

const PartidoGanador = styled.div`
	display:flex;
	flex-direction: column;
	height: 100%;
	justify-content: center;
`

const ImagenCandidato = styled.img`
	width:25%;
	height:25%;
`

const CandidatoPresidente = styled.div`
	font-weight: 500;
	font-size: 12px;
`

const CandidatoVicepresidente = styled.div`
	font-weight: 300;
	font-size: 12px;
`

const NombrePartido = styled.div`
	font-weight: 500;
	font-size: 12px;
`

const LogoPartido= styled.img`
	height: 50%;
	width: 50%;
	margin: 0 auto;
`

const Porcentaje = styled.span`
	font-weight: 600;
	font-size: 18px;
`
const Votos = styled.span`
	font-weight: 400;
	font-size: 14px;
`
const SinInformacion = styled.div`

`

function Color({ color }) {
  return (
    <div
      css={`
        width: 3px;
        flex: 0 0 auto;
        height: 20px;
        margin-right: 8px;
      `}
      style={{ background: color }}
    />
  );
}
